/* src/app/app.component.scss */
ion-split-pane {
  --side-max-width: 175px;
}
ion-menu ion-content {
  height: 100%;
}
ion-menu ion-content .main-logo {
  max-width: 90px;
  margin-left: 30px;
}
ion-menu ion-content::part(scroll) {
  display: flex;
  flex-flow: column nowrap;
}
ion-menu ion-content .header {
  width: 100%;
  margin-top: calc(var(--space-top) * 3);
  margin-bottom: calc(var(--space-bottom) * 5);
  padding: calc(env(safe-area-inset-top, 0) + var(--space-top)) var(--space-right) var(--space-bottom) var(--space-left);
  text-align: left;
}
ion-menu ion-content .content {
  flex: 1 0 auto;
}
ion-menu ion-content .content app-item {
  --icon-color: var(--ion-color-medium);
  --padding-left: 30px;
  --min-height: 56px;
  color: var(--ion-color-medium);
  font-weight: bold;
  margin: 0;
}
ion-menu ion-content .content app-item.selected {
  --icon-color: var(--ion-color-primary-contrast);
  color: var(--ion-color-primary-contrast);
  --item-background: var(--ion-color-primary);
}
ion-menu ion-content .footer {
  flex-shrink: 0;
  margin-bottom: var(--space-bottom);
  padding-bottom: env(safe-area-inset-bottom, 0);
}
ion-menu ion-content .footer .user-item {
  --icon-margin: calc(var(--space-right) / 2);
  --icon-font-size: 40px;
  --padding-bottom: 0;
}
ion-menu ion-content .footer .user-item ion-label h2 {
  font-weight: bold;
  color: #3C1A75;
}
ion-menu ion-content .footer app-item.log-out {
  --icon-color: var(--ion-color-danger);
  color: var(--ion-color-danger);
  border-bottom: 0px;
  font-weight: 700;
}
ion-menu ion-content ion-select::part(icon) {
  position: absolute;
  right: 15px;
}
.init-error {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10000;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  padding: calc(env(safe-area-inset-top, 0) + var(--space-top)) var(--space-right) calc(env(safe-area-inset-bottom, 0) + var(--space-bottom)) var(--space-left);
  background-color: #FFFFFF;
  text-align: center;
}
.init-error p {
  max-width: 360px;
  margin: 0 0 var(--space-bottom);
  color: var(--ion-color-medium);
}
.init-error app-button {
  width: 100%;
  max-width: 360px;
  margin-bottom: var(--space-bottom);
}
.init-error app-button.log-out {
  --background-color: transparent;
  --active-background-color: var(--ion-color-light);
  --text-color: var(--ion-color-danger);
}
.init-error .init-error-detail {
  width: 100%;
  max-width: 360px;
  max-height: 35vh;
  overflow: auto;
  margin: var(--space-top) 0 0;
  text-align: left;
  color: var(--ion-color-medium);
  font-size: 11px;
  white-space: pre-wrap;
  word-break: break-all;
  -webkit-user-select: text;
  user-select: text;
}
/*# sourceMappingURL=app.component-JZMZYIE4.css.map */
